import { AccountContactFormData } from './types'

export const initialAccountContactFormData: AccountContactFormData = {
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  address1: '',
  address2: '',
  city: '',
  postalCode: '',
  countryCode: '',
}

export const initialAccountContactData = {
  id: null,
  ...initialAccountContactFormData,
}
